import React, { useEffect, useState } from 'react';
import './App.css';
import Login from './components/Login/login';
import Home from './components/Home/home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showErrorToast, showSuccessToast } from './components/toast-utils';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [userType, setUserType] = useState('');

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('authenticated') === 'true';
    const savedUserType = localStorage.getItem('userType') || '';
    setAuthenticated(isAuthenticated);
    setUserType(savedUserType);
  }, [authenticated]);

  const handleLogout = (message) => {
    setAuthenticated(false);
    setUserType('');
    localStorage.removeItem('authenticated');
    localStorage.removeItem('userType');
    localStorage.removeItem('currentUser');
    if(message === 'token'){
      showErrorToast('Session expired, Please login again')
    }else{
      showSuccessToast('User logged out successfully');
    }
  };

  const handleLogin = (authenticated, type) => {
    setAuthenticated(authenticated);
    setUserType(type);
    localStorage.setItem('authenticated', authenticated);
    localStorage.setItem('userType', type);
  };

  return (
    <>
      {!authenticated && <Login onLogin={handleLogin} />}
      {authenticated && <Home userType={userType} onLogout={handleLogout} />}
      <ToastContainer />
    </>
  );
}

export default App;
